import metaBYDB from '@/constants/contents/bydb/layout/meta.json'
import ogTagsBYDB from '@/constants/contents/bydb/layout/ogTags.json'
import metaGreatestHits from '@/constants/contents/greatest_hits/layout/meta.json'
import ogTagsGreatestHits from '@/constants/contents/greatest_hits/layout/ogTags.json'
import metaSpinToWin from '@/constants/contents/spintowin/layout/meta.json'
import ogTagsSpinToWin from '@/constants/contents/spintowin/layout/ogTags.json'
import metaUltimateCoachingTrip from '@/constants/contents/ultimate_coaching_trip/layout/meta.json'
import ogTagsUltimateCoachingTrip from '@/constants/contents/ultimate_coaching_trip/layout/ogTags.json'
import {
  buildYourDreamBagTheme,
  greatestHitsTheme,
  ultimateCoachingTripTheme,
} from '@/styles'
import { spintToWinTheme } from '@/styles/theme'

export const CAMPAIGNS = {
  BYDB: {
    name: 'taylormade_bydsu_2026',
    basePath: 'buildyourdreamsetup',
    requiresLocale: true,
    theme: buildYourDreamBagTheme,
    meta: metaBYDB,
    ogTags: ogTagsBYDB,
    gtmCode: 'GTM-TBB3JXT5',
  },
  GREATESTHITS: {
    name: 'taylormade_greatest_hits_2024',
    basePath: 'greatesthits',
    alwaysRedirectClosed: false,
    requiresLocale: true,
    theme: greatestHitsTheme,
    meta: metaGreatestHits,
    ogTags: ogTagsGreatestHits,
    gtmCode: '',
  },
  ULTIMATECOACHINGTRIP: {
    name: 'taylormade_ultimate_coaching_trip_2025',
    basePath: 'ultimate_coaching_trip',
    alwaysRedirectClosed: false,
    requiresLocale: true,
    theme: ultimateCoachingTripTheme,
    meta: metaUltimateCoachingTrip,
    ogTags: ogTagsUltimateCoachingTrip,
    prefix: 'taylormade_ultimate_coaching_trip_2025',
    gtmCode: '',
  },
  SPINTOWIN: {
    name: 'taylormade_spintowin_2026',
    basePath: 'spintowin',
    alwaysRedirectClosed: false,
    requiresLocale: false,
    theme: spintToWinTheme,
    meta: metaSpinToWin,
    ogTags: ogTagsSpinToWin,
    prefix: 'taylormade_spintowin_2026',
    gtmCode: 'GTM-NHVW8HW',
  },
} as const

export const CAMPAIGN_NAMES = Object.values(CAMPAIGNS).map(
  (campaign) => campaign.name,
)

export const FALLBACK_CAMPAIGN = CAMPAIGNS.ULTIMATECOACHINGTRIP
